import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Evidence Based",
  "Data Driven Nutrition",
  "Personal Coaching",
  "Elite Performance",
  "Measured Progress",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-white/10 py-8 md:py-10 bg-[#070707]"
    >
      <Marquee speed={38} gradient gradientColor="#070707" gradientWidth={120} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-syne text-3xl md:text-5xl font-bold tracking-tight px-8 text-white/90">
              {item}
            </span>
            <span className="font-cormorant italic text-3xl md:text-5xl text-white/25 px-8">
              /
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
